import Warning from './Warning.vue';

export default Warning;



// WEBPACK FOOTER //
// ./src/components/warning/index.js